/**
 * Vendor bundle — load order from src/client/index.html bower blocks.
 * AUTO-GENERATED by webpack-migration/generate-entries.js
 */

require('bootstrap/dist/css/bootstrap.css');
require('angular-dialog-service/dist/dialogs.min.css');
require('angular-flash-alert/dist/angular-flash.css');
require('angular-grid/ng-grid.css');
require('angular-xeditable/dist/css/xeditable.css');
require('font-awesome/css/font-awesome.css');
require('ng-table/dist/ng-table.min.css');
require('toastr/build/toastr.min.css');
require('jquery/dist/jquery.js');
require('angular/angular.js');
require('angular-animate/angular-animate.js');
require('angular-ui-bootstrap/ui-bootstrap-tpls.js');
require('angular-bowser/src/angular-bowser.js');
require('angular-cookies/angular-cookies.js');
require('angular-sanitize/angular-sanitize.js');
require('angular-translate/dist/angular-translate.js');
require('angular-dialog-service/dist/dialogs.min.js');
require('angular-dialog-service/dist/dialogs.js');
require('angular-dialog-service/dist/dialogs-default-translations.min.js');
require('angular-dialog-service/dist/dialogs-default-translations.js');
require('angular-file-upload/dist/angular-file-upload.min.js');
require('angular-flash-alert/dist/angular-flash.js');
require('angular-grid/build/ng-grid.js');
require('angular-messages/angular-messages.js');
require('moment/moment.js');
require('angular-moment/angular-moment.js');
require('angular-route/angular-route.js');
require('angular-smart-table/dist/smart-table.js');
require('spin.js/spin.js');
require('angular-spinner/dist/angular-spinner.min.js');
require('messageformat/messageformat.js');
require('angular-translate-interpolation-messageformat/angular-translate-interpolation-messageformat.js');
require('angular-translate-loader-partial/angular-translate-loader-partial.js');
require('angular-translate-loader-url/angular-translate-loader-url.js');
require('angular-translate-storage-cookie/angular-translate-storage-cookie.js');
require('angular-ui-router/release/angular-ui-router.js');
require('angular-xeditable/dist/js/xeditable.js');
require('angular-utils-pagination/dirPagination.js');
require('extras.angular.plus/ngplus-overlay.js');
require('ng-file-upload/dist/ng-file-upload.js');
require('ng-table/dist/ng-table.min.js');
require('ng-idle/angular-idle.js');
require('ngstorage/ngStorage.js');
require('placeholders-dist/placeholders.js');
require('toastr/toastr.js');
require('underscore/underscore.js');
